import { Directive, Input, ViewChild } from '@angular/core';
import { FormControl, UntypedFormControl } from '@angular/forms';

import { NgUtils } from 'tiime-expert-utils';
import { SelectComponent } from 'tiime-material';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class SelectorBase<T> {
  @Input() small = false;
  @Input() emptyOptionLabel = '';
  @Input() control: FormControl;
  @Input('selectData') set setSelectData(selectData: T[]) {
    if (selectData) {
      this.selectorData = selectData;
      this.filteredSelectorData = selectData;
    }
  }

  @ViewChild(SelectComponent) selectComponent: SelectComponent;

  filteredSelectorData: T[] = [];
  searchControl: UntypedFormControl = new UntypedFormControl();
  selectorData: T[] = [];

  readonly trackById = NgUtils.trackById;
  readonly findOriginValueFromOptionsById = (value: { id?: number }, option: { id?: number }): boolean =>
    value?.id === option?.id;

  closeOptionsPanel(): void {
    this.searchControl.setValue('');
    this.searchControlChanges();
  }

  searchControlChanges(): void {
    this.filteredSelectorData = this.filterFunction(this.searchControl.value);
    this.selectComponent.focusFirstOption();
  }

  abstract filterFunction(search: string): T[];
}
